var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('module-builder',{attrs:{"schema":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }